import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";

import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import { CustomLinearProgress } from "../../../../../Components/CustomLinearProgress/CustomLinearProgress";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class MobileAddAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        title: "",
        files: "",
        subject: "",
        submissionDate: "",
      },
      tempFiles: [],
      fileUrl: [],
      fileLoading: "",
      filePercentage: "",
      fileError: "",
      fileToDelete: "",
      deleteFile: false,
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleFile = async (e) => {
    let files = e.target.files;
    this.setState({
      tempFiles: files,
      fileLoading: true,
      fileUrl: [],
    });

    for (let i = 0; i <= e.target.files.length - 1; i++) {
      let file = e.target.files[i];
      let reader = new FileReader();
      reader.onload = () => {
        this.setState({
          fileUrl: [...this.state.fileUrl, window.URL.createObjectURL(file)],
        });
      };
      reader.readAsDataURL(file);
      reader.onprogress = (data) => {
        this.setState({
          fileLoading: false,
        });
        if (data.lengthComputable) {
          var progress = parseInt((data.loaded / data.total) * 100, 10);
          this.setState({
            filePercentage: progress,
          });
        }
      };
    }
  };

  handleFileProgress = () =>
    this.state.filePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.filePercentage}
          variant="determinate"
        />
        {this.state.filePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.filePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  uploadFile = async (files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: "Assignment",
      contentType: files.type,
    });
    await Axios.put(signedUrl, files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  filterData = (data) => {
    let changedData = data;
    if (!data.faculty) {
      delete changedData.faculty;
    }

    if (!data.group) {
      delete changedData.group;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let data = {
        ...this.state.data,
        session: this.props.config.session.toString(),
        studentClass: this.props.config.class,
        faculty: this.props.config.faculty,
        group: this.props.config.group,
        section: this.props.config.section,
      };
      let fileKeys = [];
      for (let i = 0; i <= this.state.tempFiles.length - 1; i++) {
        fileKeys.push(await this.uploadFile(this.state.tempFiles[i]));
      }
      let changedData = this.filterData(data);
      let toSubmitData = { ...changedData, files: fileKeys };
      const response = await Axios.post(
        `${url}/api/assignments`,
        toSubmitData,
        {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        }
      );
      if (response.data.message === "Assignment added successfully") {
        this.setState({
          data: {
            title: "",
            files: "",
            subject: "",
            submissionDate: "",
          },
          tempFiles: [],
          fileUrl: [],
          fileLoading: "",
          filePercentage: "",
          fileError: "",
          loading: false,
        });
        this.props.getAssignments();
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper style={{ padding: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Tooltip
            arrow
            title="Cancel"
            onClick={() => this.props.handleAddStatus(false)}
          >
            <CancelIcon />
          </Tooltip>
        </div>
        <TextField
          name="title"
          type="text"
          label="Title"
          required
          fullWidth
          placeholder="E.g, Chapter 1 notes, syllabus and more"
          variant="outlined"
          margin="normal"
          style={{ marginRight: 20 }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.state.data.title}
          onChange={this.handleChange}
        />
        <div>Insert File Document</div>
        {this.state.fileUrl.length > 0 ? (
          <CheckCircleIcon />
        ) : (
          this.state.data.files && <CheckCircleIcon />
        )}
        <div>
          <input
            type="file"
            multiple
            accept="application/*"
            onChange={this.handleFile}
          />
          <div>
            <div style={{ padding: 10 }}>{this.handleFileProgress()}</div>
            <div>{this.state.fileLoading === true && <CircularProgress />}</div>
          </div>
          <div style={{ color: "red", fontWeight: "bold" }}>
            {this.state.fileError}
          </div>
        </div>
        <TextField
          name="subject"
          select
          label="Subject"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          style={{ marginRight: 20 }}
          SelectProps={{ native: true }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.state.data.subject}
          onChange={this.handleChange}
        >
          <option value="">Select Any One</option>
          {this.props.subjects.map((subject, index) => (
            <option key={index} value={subject.name}>
              {subject.name}
            </option>
          ))}
        </TextField>
        <TextField
          name="submissionDate"
          type="date"
          label="Deadline"
          required
          fullWidth
          variant="outlined"
          margin="normal"
          style={{ marginRight: 20 }}
          SelectProps={{ native: true }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.state.data.submissionDate}
          onChange={this.handleChange}
        />
        <div>
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            onClick={this.handleSubmit}
          >
            Add
          </Button>
          {this.state.loading && <FormLoader />}
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(MobileAddAssignment)));
